export type AdminRole = 'user' | 'manager' | 'admin' | 'superadmin' | string | null | undefined

export type AdminNavItemKey =
  | 'account'
  | 'infrastructure'
  | 'organizations'
  | 'users'
  | 'teams'
  | 'srt_bridges'
  | 'private_beta'

export interface AdminNavItem {
  key: AdminNavItemKey
  href: string
  label: string
  platformOnly: boolean
}

export function isPlatformAdminRole(role: AdminRole) {
  return role === 'superadmin'
}

export function isOrganizationAdminRole(role: AdminRole) {
  return role === 'admin'
}

export function canAccessAdmin(role: AdminRole) {
  return isPlatformAdminRole(role) || isOrganizationAdminRole(role)
}

export function canAccessPlatformAdmin(role: AdminRole) {
  return isPlatformAdminRole(role)
}

export function getAdminLandingKind(role: AdminRole): 'platform' | 'organization' | 'denied' {
  if (isPlatformAdminRole(role)) return 'platform'
  if (isOrganizationAdminRole(role)) return 'organization'
  return 'denied'
}

export function getAdminNavItems(role: AdminRole): AdminNavItem[] {
  if (isPlatformAdminRole(role)) {
    return [
      { key: 'infrastructure', href: '/admin', label: 'Infrastructure', platformOnly: true },
      { key: 'organizations', href: '/admin/organizations', label: 'Organizations', platformOnly: true },
      { key: 'users', href: '/admin/users', label: 'Users', platformOnly: false },
      { key: 'teams', href: '/admin/teams', label: 'Teams', platformOnly: false },
      { key: 'srt_bridges', href: '/admin/srt-bridges', label: 'SRT bridges', platformOnly: true },
      { key: 'private_beta', href: '/admin/private-beta', label: 'Private beta', platformOnly: true },
    ]
  }

  if (isOrganizationAdminRole(role)) {
    return [
      { key: 'account', href: '/admin', label: 'Account', platformOnly: false },
      { key: 'users', href: '/admin/users', label: 'Users', platformOnly: false },
      { key: 'teams', href: '/admin/teams', label: 'Teams', platformOnly: false },
    ]
  }

  return []
}

export function assignableRolesFor(role: AdminRole) {
  const roles = ['user', 'manager', 'admin']

  if (isPlatformAdminRole(role)) {
    return [...roles, 'superadmin']
  }

  return roles
}
